import React from 'react';
import { FilterSelect } from './FilterSelect';

export const ListFiltersBar = ({
    searchField,
    onSearchFieldChange,
    searchFieldOptions,
    searchTerm,
    onSearchTermChange,
    statusFilter,
    onStatusFilterChange,
    statusOptions,
    rowsPerPage,
    onRowsPerPageChange,
    rowsOptions = [10, 20, 50, 100],
    extraFilters = [],
    onClearFilters,
    searchPlaceholder = 'Escribe para buscar...',
    clearLabel = 'Limpiar filtros',
}) => {
    return (
        <div className="card__stat border-0 mb-2 list-filters-bar">
            <div className="card-body py-2 px-2 px-md-3">
                <div className="row g-1 align-items-end">
                    <div className="col-lg-2 col-md-4">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Buscar por</label>
                        <FilterSelect
                            value={searchField}
                            options={searchFieldOptions}
                            onChange={onSearchFieldChange}
                        />
                    </div>

                    <div className="col-lg-4 col-md-8">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Buscar</label>
                        <input
                            type="search"
                            className="form-control form-control-sm"
                            placeholder={searchPlaceholder}
                            value={searchTerm}
                            onChange={({ target }) => onSearchTermChange(target.value)}
                        />
                    </div>

                    <div className="col-lg-2 col-md-4">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Estatus</label>
                        <FilterSelect
                            value={statusFilter}
                            options={statusOptions}
                            onChange={onStatusFilterChange}
                        />
                    </div>

                    {extraFilters.map((filter) => (
                        <div key={filter.key} className={filter.colClassName || 'col-lg-2 col-md-4'}>
                            <label className="form-label form-label-sm mb-1 fw-semibold">{filter.label}</label>
                            <FilterSelect
                                value={filter.value}
                                options={filter.options || []}
                                onChange={filter.onChange}
                            />
                        </div>
                    ))}

                    <div className="col-lg-2 col-md-4">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Mostrar</label>
                        <FilterSelect
                            value={rowsPerPage}
                            options={rowsOptions.map((option) => ({ value: option, label: String(option) }))}
                            onChange={(nextValue) => onRowsPerPageChange(Number(nextValue))}
                        />
                    </div>

                    <div className="col-lg-2 col-md-4 d-grid">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm w-100"
                            onClick={onClearFilters}
                        >
                            {clearLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
